import React from 'react';
import { Meet as MeetModel } from '../../../../models/meet';
import { formatDateLocale } from '../../../../utils/formatDateLocale';
import { Book } from '../Book/Book';
import styles from './Meet.module.scss';
import {
  LinkOutlined,
  FileTextOutlined,
  EnvironmentOutlined
} from '@ant-design/icons';

interface Props{
  meet: MeetModel;
}

const Meet = ({meet}: Props) => {
 
  const copy = (event) => {
    navigator.clipboard.writeText(event.value)
    alert("O texto é: " + event.value);
  }

  return (
    <div className={styles.meetContainer}>
      <div className={styles.meetBook}>
        <Book
          key={meet.bookId} 
          bookId={meet.bookId}/>
      </div>
      <div className={styles.meetInfo}>
        <h1><strong>{formatDateLocale(meet.dateMeet)}</strong></h1>
        {meet?.link && 
          <>
            <br/>
            <h2><strong><LinkOutlined /> Link:</strong> <span>{meet?.link || ''}</span></h2>
          </>
        }
        {meet?.location && 
          <>
            <br/>
            <h2><strong><EnvironmentOutlined /> Local:</strong> <span>{meet?.location || ''}</span></h2>
          </>
        }
        {meet?.notes && 
          <>
            <br/>
            <h2><strong><FileTextOutlined /> Notas:</strong> <span>{meet?.notes || ''}</span></h2>
          </>
        }
      </div>
    </div>
  )
}

export default Meet;